import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import Vehicles from "./pages/Vehicles";
import VehicleDetail from "./pages/VehicleDetail";
import HowItWorksPage from "./pages/HowItWorksPage";
import ForCompanies from "./pages/ForCompanies";
import Pricing from "./pages/Pricing";
import LegalPage from "./pages/LegalPage";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import CompanyPublic from "./pages/CompanyPublic";
import DriverLayout from "./components/driver/DriverLayout";
import DriverHome from "./pages/driver/DriverHome";
import DriverDocuments from "./pages/driver/DriverDocuments";
import DriverBookings from "./pages/driver/DriverBookings";
import DriverBookingDetail from "./pages/driver/DriverBookingDetail";
import DriverMessages from "./pages/driver/DriverMessages";
import DriverFavourites from "./pages/driver/DriverFavourites";
import DriverReviews from "./pages/driver/DriverReviews";
import DriverProfilePage from "./pages/driver/DriverProfilePage";
import CompanyOverview from "./pages/company/CompanyOverview";
import CompanyListings from "./pages/company/CompanyListings";
import CompanyListingEditor from "./pages/company/CompanyListingEditor";
import CompanyListingDetail from "./pages/company/CompanyListingDetail";
import CompanyBookings from "./pages/company/CompanyBookings";
import CompanyBookingDetail from "./pages/company/CompanyBookingDetail";
import CompanyCalendar from "./pages/company/CompanyCalendar";
import CompanyCustomers from "./pages/company/CompanyCustomers";
import CompanyMessages from "./pages/company/CompanyMessages";
import CompanySubscription from "./pages/company/CompanySubscription";
import CompanyProfile from "./pages/company/CompanyProfile";
import CompanyReviews from "./pages/company/CompanyReviews";
import CompanyConvert from "./pages/company/CompanyConvert";
import CompanyComingSoon from "./pages/company/CompanyComingSoon";
import CompanyLayout from "./components/company/CompanyLayout";
import RequireAuth from "./components/auth/RequireAuth";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/vehicles" element={<Vehicles />} />
        <Route path="/vehicles/:slug" element={<VehicleDetail />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/partners" element={<ForCompanies />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/legal" element={<LegalPage page="legal" />} />
        <Route path="/privacy" element={<LegalPage page="privacy" />} />
        <Route path="/terms" element={<LegalPage page="terms" />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/tag/:tagSlug" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogArticle />} />
        <Route path="/companies/:publicId" element={<CompanyPublic />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/partners/signup" element={<Signup role="company" />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route
          path="/driver"
          element={
            <RequireAuth role="driver">
              <DriverLayout />
            </RequireAuth>
          }
        >
          <Route index element={<DriverHome />} />
          <Route path="documents" element={<DriverDocuments />} />
          <Route path="bookings" element={<DriverBookings />} />
          <Route path="bookings/:id" element={<DriverBookingDetail />} />
          <Route path="messages" element={<DriverMessages />} />
          <Route path="messages/:id" element={<DriverMessages />} />
          <Route path="favourites" element={<DriverFavourites />} />
          <Route path="reviews" element={<DriverReviews />} />
          <Route path="profile" element={<DriverProfilePage />} />
          {/* Not built yet */}
          <Route path="*" element={<CompanyComingSoon />} />
        </Route>
        <Route
          path="/company"
          element={
            <RequireAuth role="company">
              <CompanyLayout />
            </RequireAuth>
          }
        >
          <Route index element={<CompanyOverview />} />
          <Route path="listings" element={<CompanyListings />} />
          <Route path="listings/new" element={<CompanyListingEditor />} />
          <Route path="listings/:id" element={<CompanyListingDetail />} />
          <Route path="listings/:id/edit" element={<CompanyListingEditor />} />
          <Route path="bookings" element={<CompanyBookings />} />
          <Route path="bookings/:id" element={<CompanyBookingDetail />} />
          <Route path="calendar" element={<CompanyCalendar />} />
          <Route path="customers" element={<CompanyCustomers />} />
          <Route path="messages" element={<CompanyMessages />} />
          <Route path="messages/:id" element={<CompanyMessages />} />
          <Route path="reviews" element={<CompanyReviews />} />
          <Route path="subscription" element={<CompanySubscription />} />
          <Route path="profile" element={<CompanyProfile />} />
          <Route path="profile/convert" element={<CompanyConvert />} />
          <Route path="*" element={<CompanyComingSoon />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
